import React, { useState, useEffect } from "react";
import "./myAccount.css"
import { connect } from 'react-redux'
import { sendRequest, beforeRequest } from '../../redux/user/user.action'
import MessageAlert from "../messageAlert/messageAlert";
import CheckSecurity from "../qrCode/checkSecurity";
import SubmitLoader from "../submitLoader/submitLoader";
import { Table, Nav, Tab, Container, Modal } from "react-bootstrap";


function DeletingAccount(props) {
    const [loader, setLoader] = useState(false)
    const [successMsg, setSuccessMsg] = useState(null)
    const [showAlertMsgModal, setShowAlertMsgModal] = useState(false)
    const [renderSecurity, setRednerSecuirty] = useState(false);
    const [description, setDescription] = useState('')
    const [cancelRequestModal, setCancelRequestModal] = useState();

    const [err, setErr] = useState('');

    useEffect(() => {
        if (props.user.sendRequestAuth) {
            setLoader(false)
            setDescription("")
            setShowAlertMsgModal(true)
            setSuccessMsg(props.user.sendRequestMessage)
            props.beforeRequest()
        }
    }, [props.user.sendRequestAuth])

    const deleteAcc = () => {
        if(!description || !description.trim())
        {
            setErr('Add a valid reason to delete your Account')
           
        }
        else{
        setErr('')
        setCancelRequestModal(true)
     }
        // let payload = {
        //     type: 1 // account deletion request
        // }
        // props.beforeRequest()
        // props.sendRequest(payload)
    }

    const setVerified = (value) => {
        if (value) {
            let payload = {
                type: 1, // account deletion request
                description
            }
            props.beforeRequest()
            props.sendRequest(payload)
        }
        setRednerSecuirty(false)
    }

    const deleteRequest = () => {
        setRednerSecuirty(true)
        setCancelRequestModal(false)      
    }


    return (
        <>
            <MessageAlert
                type={successMsg === "You already have requested for account deletion." ? "warning" : "success"}
                greeting={successMsg === "You already have requested for account deletion." ? "Sorry!" : "We are sad to see you go!"}
                description={successMsg}
                show={showAlertMsgModal}
                onHide={setShowAlertMsgModal}
            />
            {renderSecurity && <CheckSecurity setVerified={setVerified} securityType="accountDeletion" redirctPath="/my-account" />}

            <div className="deleting-account">
                {/* <div className="card">
                <label>Status: -</label>
                <label>Admin notes: -</label>
                <label>User notes: -</label>
             </div> */}
                <h2>Notes</h2>
                <textarea className="card" value={description} onChange={(e)=> setDescription(e.target.value)} />
                {err && <p className="error text-center">{err}</p>}

                <div className="d-flex justify-content-center align-items-center">
                    <button onClick={() => (deleteAcc())} className="btn-triage-div btn-triage"><span>Delete Account</span>{loader && <SubmitLoader />}</button>
                </div>
            </div>

            <Modal
            show={cancelRequestModal}
            onHide={() => setCancelRequestModal(false)}
            className="deposit-request-modal"
            size="lg"
            backdrop="static"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Confirm Account Deletion
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to send request for account deletion? </p>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
              <div className="d-flex justify-content-center flex-wrap">
                <button
                  onClick={() => setCancelRequestModal(false)}
                  className="btn-triage-div btn-triage me-4 mb-3 mb-md-0 me-3 d-flex justify-content-center align-items-center"
                >
                  <span>CANCEL</span>
                </button>
                <button
                  onClick={() => deleteRequest()}
                  className="btn-triage-div btn-triage me-4 mb-3 mb-md-0 me-3 d-flex justify-content-center align-items-center"
                >
                  <span>CONFIRM</span>
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        </>
    )
}

const mapStateToProps = (state) => ({
    user: state.user
})

export default connect(mapStateToProps, { sendRequest, beforeRequest })(DeletingAccount)